"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventClient = exports.EventClient = void 0;
var BEHAVIOR_PREFIX;
(function (BEHAVIOR_PREFIX) {
    BEHAVIOR_PREFIX["SCREEN"] = "screen";
    BEHAVIOR_PREFIX["CLICK"] = "click";
})(BEHAVIOR_PREFIX || (BEHAVIOR_PREFIX = {}));
class EventClient {
    constructor(...adapters) {
        this.adapters = new Set();
        this.enableIgnorePattern = true;
        this.enableScreenTracking = true;
        this.enableClickTracking = true;
        this.defaultIgnorePattern = /(care-|care|-care)/gmi;
        if ((adapters === null || adapters === void 0 ? void 0 : adapters.length) !== 0) {
            adapters.forEach((adapter) => this.adapters.add(adapter));
        }
    }
    addAdapter(adapter) {
        this.adapters.add(adapter);
    }
    setEnableIgnorePattern(value) {
        this.enableIgnorePattern = value;
    }
    setEnableScreenTracking(value) {
        this.enableScreenTracking = value;
    }
    setEnableClickTracking(value) {
        this.enableClickTracking = value;
    }
    /**
     * Log a screen event
     * @param type A string presents for this event context
     * @param payload A object contain additional information of this event. Can be skip
     */
    log(type, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.adapters.forEach((adapter) => { var _a, _b; return (_b = (_a = adapter.logEvent(type, payload)) === null || _a === void 0 ? void 0 : _a.catch) === null || _b === void 0 ? void 0 : _b.call(_a, console.debug); });
        });
    }
    /**
     * Log a screen event (deprecated function - only for Host Project)
     * @param event A event object which inherits for BaseEvent class
     */
    logEvent(event) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.log(event.type, event.payload);
        });
    }
    /**
     * Log a behavior event
     * @param type A string presents for this event context following pre-defined rule
     * @param payload A object contains additional information of this event context. Can be skip
     * @param config A object contains config of log even. Can be skip
     */
    logBehaviourEvent(type, payload, config = {}) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            let simplifiedType = type
                .split(/[^a-z0-9]/gi)
                .map(w => w.charAt(0).toUpperCase() + w.slice(1))
                .join('');
            if (this.enableIgnorePattern) {
                const behaviorRegex = config.ignorePattern || this.defaultIgnorePattern;
                simplifiedType = simplifiedType.replace(behaviorRegex, '');
            }
            simplifiedType = [(_a = config.prefix) === null || _a === void 0 ? void 0 : _a.toUpperCase(), simplifiedType, (_b = config.postfix) === null || _b === void 0 ? void 0 : _b.toUpperCase()].filter(part => !!part).join('_');
            return this.log(simplifiedType, payload);
        });
    }
    /**
     * Log a screen event
     * @param id A string presents for this screen context following pre-defined rule
     * @param params A object contain additional information of this screen context. Can be skip
     */
    logScreenEvent(id, params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.enableScreenTracking) {
                // Do nothing
                return Promise.resolve();
            }
            return this.logBehaviourEvent(id, params, {
                prefix: BEHAVIOR_PREFIX.SCREEN,
                ignorePattern: this.defaultIgnorePattern
            });
        });
    }
    /**
     * Log a click event
     * @param id A string presents for this click context following pre-defined rule
     * @param params A object contain additional information of this screen context. Can be skip
     */
    logClickEvent(id, params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.enableClickTracking) {
                // Do nothing
                return Promise.resolve();
            }
            return this.logBehaviourEvent(id, params, {
                prefix: BEHAVIOR_PREFIX.CLICK,
                ignorePattern: this.defaultIgnorePattern
            });
        });
    }
    setUserProperties(properties) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.adapters.forEach((adapter) => { var _a, _b; return (_b = (_a = adapter.setUserProperties(properties)) === null || _a === void 0 ? void 0 : _a.catch) === null || _b === void 0 ? void 0 : _b.call(_a, console.debug); });
        });
    }
    setUserId(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.adapters.forEach((adapter) => { var _a, _b; return (_b = (_a = adapter.setUserId(id)) === null || _a === void 0 ? void 0 : _a.catch) === null || _b === void 0 ? void 0 : _b.call(_a, console.debug); });
        });
    }
}
exports.EventClient = EventClient;
exports.eventClient = new EventClient();
//# sourceMappingURL=event-tracking.js.map